import React from 'react';
import styled from 'styled-components';

const B6Style = styled.svg``;

export const B6 = ({ color }) => {
	return (
		<B6Style
			xmlns='http://www.w3.org/2000/svg'
			width='18.6'
			height='27.813'
			viewBox='0 0 18.6 27.813'
		>
			<path
				id='Big_Ben'
				data-name='Big Ben'
				d='M696.642,396a.858.858,0,0,1,0-1.716h5.486V383.316H702a.509.509,0,0,1-.51-.513v-6.171a.511.511,0,0,1,.5-.513h.06l.256-.367.388-.554v-2.534a.753.753,0,0,1,.013-.128.386.386,0,0,1,.048-.115l.936-1.972.935-1.969a.491.491,0,0,1,.286-.264.534.534,0,0,1,.4.019.663.663,0,0,1,.145.1.637.637,0,0,1,.1.143l.942,1.984.941,1.981c.013.037.025.073.036.11s.007.073.007.109h0V375.2l.4.571.25.349h.06a.515.515,0,0,1,.5.513V382.8a.514.514,0,0,1-.51.513h-.14v10.968h5.5a.858.858,0,0,1,0,1.716Zm6.654-19.882h3.579l-.158-.234-.17-.237a.385.385,0,0,1-.085-.151.453.453,0,0,1-.037-.183.2.2,0,0,1,.012-.085.326.326,0,0,1,.019-.085v-1.88H703.72v1.89a.5.5,0,0,1,.019.234.456.456,0,0,1-.086.222l-.182.255-.176.255Zm.68-3.886h2.218l-.425-.9-.68-1.444-.681,1.444-.432.9Zm-.133,11.083h0v10.968h2.486V383.316h-2.486Zm-1.33-6.167h0v1.361a2.831,2.831,0,0,1,1.367-1.361h-1.367Zm0,3.773h0v1.363h1.367a2.831,2.831,0,0,1-1.367-1.363Zm3.778,1.363h1.362v-1.363a2.852,2.852,0,0,1-1.362,1.363Zm1.362-3.776h0v-1.361H706.29a2.852,2.852,0,0,1,1.362,1.361Zm-2.564-.6h0a1.812,1.812,0,1,0,1.811,1.813,1.821,1.821,0,0,0-1.811-1.813Zm-.517.617h0v1.2a.513.513,0,0,0,.517.511h.971a.513.513,0,0,0,0-1.027H705.6v-.68a.513.513,0,1,0-1.027,0Z'
				transform='translate(-695.785 -368.188)'
				fill={color}
			/>
		</B6Style>
	);
};
